import RouteCategoryNote from "common/RouteCategoryNote";
import RouteListRenderer from "common/RouteListRenderer";

const PAGE_NAME = "District Series Buses (Kolkata and Howrah)";

const DistrictSeriesBusesKolkataHowrah = () => {
  document.title = `${PAGE_NAME} - Banglar Transit`;

  return (
    <main>
      <RouteListRenderer busRouteCategory={PAGE_NAME}>
        <p className="my-4">
          Here we list the specially numbered district buses which are visible
          in and around Howrah, North and South and 24 Parganas. These are
          generally express buses, with some being local and can be seen as city
          services as well. Most of them have different colour schemes, while
          some may follow the usual blue-yellow (or blue-white) scheme.
        </p>

        <RouteCategoryNote pageName={PAGE_NAME} />
      </RouteListRenderer>
    </main>
  );
};

export default DistrictSeriesBusesKolkataHowrah;
